var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImportant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6666 14L26.4132 10.2933L26.8666 5.38668L22.0533 4.29334L19.5333 0.0533447L14.9999 2.00001L10.4666 0.0533447L7.94658 4.29334L3.13325 5.37334L3.58659 10.28L0.333252 14L3.58659 17.7067L3.13325 22.6267L7.94658 23.72L10.4666 27.96L14.9999 26L19.5333 27.9467L22.0533 23.7067L26.8666 22.6133L26.4132 17.7067L29.6666 14ZM16.3333 20.6667H13.6666V18H16.3333V20.6667ZM16.3333 15.3333H13.6666V7.33334H16.3333V15.3333Z",
    fill: "#1D253C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportant);
export default __webpack_public_path__ + "static/media/icon-important.774c2f7ab47a9ff98b7fa72606a813bf.svg";
export { ForwardRef as ReactComponent };